import React from 'react';

interface CloseCircleIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	fill?: string;
}

export function CloseCircleIcon({
	width = 24,
	height = 24,
	fill = 'currentColor',
	...props
}: Readonly<CloseCircleIconProps>) {
	return (
		<svg
			{...props}
			fill="none"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.9558 6.85433C16.2847 7.10605 16.3473 7.57678 16.0956 7.90573L12.9564 12.0081L16.092 16.0395C16.3463 16.3665 16.2874 16.8377 15.9605 17.092C15.6335 17.3463 15.1623 17.2874 14.908 16.9605L12.014 13.2396L9.16665 16.9605C8.91493 17.2895 8.4442 17.3521 8.11525 17.1004C7.7863 16.8486 7.72369 16.3779 7.97541 16.049L11.0619 12.0155L7.90799 7.96046C7.65368 7.6335 7.71258 7.16229 8.03954 6.90799C8.3665 6.65368 8.83771 6.71258 9.09201 7.03954L12.0043 10.784L14.9044 6.99417C15.1561 6.66522 15.6268 6.60261 15.9558 6.85433Z"
				fill={fill}
			/>
		</svg>
	);
}
